export default [
  {
    fieldName: 'Password',
    label: 'New password',
    type: 'password',
    isRequired: true,
  },
  {
    fieldName: 'PasswordAgain',
    label: 'Confirm new password',
    type: 'password',
    equal: 'Password',
    isRequired: true,
  },
];


// WEBPACK FOOTER //
// ./src/formFields/recoverPw.tsx